import { useBetLimit, useBetLimitState } from '@/hooks/useBetLimit';
import { createContext } from 'react';

export const BetLimitContext = createContext({} as useBetLimitState);
const { Provider } = BetLimitContext;
type BetLimitProviderProps = {
    children: JSX.Element;
};
export const BetLimitProvider = (props: BetLimitProviderProps) => {
    const { children } = props;
    const betLimit = useBetLimit();
    return <Provider value={betLimit}>{children}</Provider>;
};
